import React, { useContext, useEffect, useRef, useState } from "react";
import DashboardData from "../../assets/raw/dashboard.json";
import Services from "./components/Services";
import QuickTransfer from "./components/QuickTransfer/QuickTransfer";
import RecentTsns from "./components/RecentTransactions";
import RegisterDebtView from "./components/RegisterDebtView";
import AccountHave from "./components/AccountHave";

import {
  fetchPortfolio,
  getRecentTransactionList,
  logout,
} from "../../network/Apiservices";
import HomeSkimmer from "./components/HomeSkimmer";
import { useAuth } from "../../hooks/useAuth";
import ApiContext from "../../network/KeyExchangeWrapper";
import { initToast } from "../../network/serverErrorHandler";
import SelectDevice from "../core/components/SelectDevice";
import ApproveTransfer from "../core/components/ApproveTransfer.tsx";
import { transferWeights } from "../../constants/config";
import { useNavigate } from "react-router-dom";
import StSecureCommSession from "../SecureCommunication";
import { StCryptoSymmetricOperator } from "../SecureCommunication/StCryptoSymmetricOperator";
import { setPortFolio } from "../dashboard/redux/accountSlice";
import { useDispatch } from "react-redux";
import { useLocationContext } from "../location/context/locationContext";
import { useTheme } from "../../theme/ThemeProvider";
import EnableOpenBanking from "./components/EnableOpenBanking";
import OpenBanking from "./components/OpenBanking";
import { useOpenBanking } from "../location/context/OpenBankingContext";

interface ComponentProps {
  // Define your prop types here
}

const defaultState = {
  recentTransactionsList: [],
  accountsHave: [],
  accountsOwe: [],
  youHaveAmount: "",
  youOweAmount: "",
  isDebtViewOpen: false,
  isDeviceListModelOpen: false,
  isApproveModelOpen: false,
  mfaPayload: null,
  otp: "",
  status: null,
  otpError: "",
};
const Home: React.FC<ComponentProps> = (props) => {
  const [state, setState] = useState(defaultState);
  const { user } = useAuth();
  const context = useContext(ApiContext);
  const { parentData, loading, error, isSecureChannelEnabled } = context || {};
  const dispatch = useDispatch();
  console.log("isSecureChannelEnabled", isSecureChannelEnabled);
  const { locationData } = useLocationContext();
  const { theme } = useTheme();
  const { isOpenBanking } = useOpenBanking();
  const navigate = useNavigate();
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    else {
      if (error) {
        initToast(error);
      }
      if (!loading && !error) {
        getPortfolioApi("USE_EFFECT");

        initialized.current = true;
      }
    }
  }, [parentData]); // eslint-disable-line react-hooks/exhaustive-deps

  const getPortfolioApi = async (from: string, payload?: any) => {
    let response: any;
    switch (from) {
      case "USE_EFFECT":
        response = await fetchPortfolio(undefined, locationData);
        if (response?.headers["X-EK-MFA-CHALLENGE-PAYLOAD"]) {
          const mfaPayload = JSON.parse(response.headers["X-EK-MFA-CHALLENGE-PAYLOAD"]);
          if (mfaPayload.deviceList && mfaPayload.deviceList.length > 0) {
            setState((prevState) => ({
              ...prevState,
              mfaPayload: mfaPayload,
              isDeviceListModelOpen: true,
            }));
            dispatch(setPortFolio(response.data));
            return;
          } else if (
            mfaPayload.weight === "SMS" ||
            (transferWeights as any)[mfaPayload.weight]
          ) {
            setState((prevState) => ({
              ...prevState,
              mfaPayload: mfaPayload,
              isApproveModelOpen: true,
            }));
          }
        }
        if (response.data) {
          console.log("response.data", response.data);
          dispatch(setPortFolio(response.data));
          setState((prevState: any) => ({
            ...prevState,
            status: "APPROVED",
            accountsHave: response.data.youHaveAccounts,
            accountsOwe: response.data.youOweAccounts,
            youHaveAmount: response.data.youHaveAmountLcyFormat,
            youOweAmount: response.data.youOweAmountLcyFormat,
          }));
          getRecentTransList();
        }
        break;

      case "portfolioSubmitHandler":
        try {
          if (
            payload.weight !== "SMS" &&
            isSecureChannelEnabled &&
            payload.totp
          ) {
            const useSecureSession = StSecureCommSession.getInstance();
            const stSymmetricKey = useSecureSession.getSymmetricKey();
            const encryptedOtp =
              await StCryptoSymmetricOperator.getInstance().encrypt(
                payload.totp,
                stSymmetricKey!
              );
            payload.totp = encryptedOtp;
          }
          if (payload.weight.includes("STOTP") && payload.totp) {
            let weight = payload.weight.replace("STOTP", "TOTP");
            payload.weight = weight;
          }

          const portfolioSubmitResponse = await fetchPortfolio(
            payload,
            locationData
          );

          if (portfolioSubmitResponse?.headers["X-EK-MFA-CHALLENGE-PAYLOAD"]) {
            const mfaPayload = JSON.parse(
              portfolioSubmitResponse.headers["X-EK-MFA-CHALLENGE-PAYLOAD"]
            );
            setState((prevState) => ({
              ...prevState,
              mfaPayload: mfaPayload,
              otpError: "Invalid PIN. Try using the correct PIN",
            }));
          } else {
            dispatch(setPortFolio(portfolioSubmitResponse.data));
            setState((prevState: any) => ({
              ...prevState,
              isApproveModelOpen: false,
              mfaPayload: null,
              status: "APPROVED",
              otpError: "",
              accountsHave: portfolioSubmitResponse.data.youHaveAccounts,
              accountsOwe: portfolioSubmitResponse.data.youOweAccounts,
              youHaveAmount:
                portfolioSubmitResponse.data.youHaveAmountLcyFormat,
              youOweAmount: portfolioSubmitResponse.data.youOweAmountLcyFormat,
            }));
            getRecentTransList();
          }
        } catch (error: any) {
          console.log("error submit otp for portfolio:", error);
          if (error === "ERR_901") {
            initToast("Your Request has been timed out. App will logout");
            navigate("/auth/login");
            logout();
          }
          if (error === "ERR_902") {
            initToast(
              "You have exceeded the number of attempts. App will logout"
            );
            navigate("/auth/login");
            logout();
          }
        }
        break;

      case "navigateToApproveModal":
        try {
          const responseAfterAddingDevice = await fetchPortfolio(
            payload,
            locationData
          );
          if (responseAfterAddingDevice.headers["X-EK-MFA-CHALLENGE-PAYLOAD"]) {
            const mfaPayload = JSON.parse(
              responseAfterAddingDevice.headers["X-EK-MFA-CHALLENGE-PAYLOAD"]
            );
            if (mfaPayload.deviceList && mfaPayload.deviceList.length > 0) {
              setState((prevState) => ({
                ...prevState,
                mfaPayload: mfaPayload,
                isDeviceListModelOpen: true,
              }));
              return;
            } else if (
              mfaPayload.weight === "SMS" ||
              (transferWeights as any)[mfaPayload.weight]
            ) {
              setState((prevState) => ({
                ...prevState,
                mfaPayload: mfaPayload,
                isApproveModelOpen: true,
              }));
            }
          }
          if (responseAfterAddingDevice.data) {
            dispatch(setPortFolio(responseAfterAddingDevice.data));
            setState((prevState) => ({
              ...prevState,
              accountsHave: response.data.youHaveAccounts,
              accountsOwe: response.data.youOweAccounts,
              youHaveAmount: response.data.youHaveAmountLcyFormat,
              youOweAmount: response.data.youOweAmountLcyFormat,
            }));
            getRecentTransList();
          }
        } catch (error) {
          console.log("error fetching portfolio", error);
        }
        break;
      case "portfolioSubmitHandlerOnStatus":
        try {
          payload.totp = "verified";
          const portfolioSubmitResponse = await fetchPortfolio(
            payload,
            locationData
          );

          console.log("portfolioSubmitResponse", portfolioSubmitResponse);
          dispatch(setPortFolio(portfolioSubmitResponse.data));
          setState((prevState: any) => ({
            ...prevState,
            isApproveModelOpen: false,
            mfaPayload: null,
            status: "APPROVED",
            otpError: "",
            accountsHave: portfolioSubmitResponse.data.youHaveAccounts,
            accountsOwe: portfolioSubmitResponse.data.youOweAccounts,
            youHaveAmount: portfolioSubmitResponse.data.youHaveAmountLcyFormat,
            youOweAmount: portfolioSubmitResponse.data.youOweAmountLcyFormat,
          }));
          getRecentTransList();
        } catch (error) {
          if (error === "ERR_901") {
            initToast("Your Request has been timed out. App will logout");
            navigate("/auth/login");
            logout();
          }
        }
        break;
      default:
        break;
    }
  };

  const getRecentTransList = async () => {
    const response = await getRecentTransactionList();
    if (response?.data && response?.data?.transactions.length > 0) {
      setState((prevState) => ({
        ...prevState,
        recentTransactionsList: !user?.isRegistered
          ? response?.data?.transactions.slice(0, 7)
          : response?.data?.transactions.slice(0, 5),
      }));
    }
  };

  const toggleDeviceListModel = () => {
    setState((prevState) => ({
      ...prevState,
      isDeviceListModelOpen: !prevState.isDeviceListModelOpen,
    }));
  };

  const toggleApprove = () => {
    if (state.isApproveModelOpen) {
      localStorage.setItem("user", "null");
      navigate("/auth/login");
    }
    setState((prevState) => ({
      ...prevState,
      isAppoveModelOpen: !prevState.isApproveModelOpen,
    }));
  };

  const navigateToApproveModal = async (device: any) => {
    try {
      setState((prevState: any) => ({
        ...prevState,
        isDeviceListModelOpen: false,
        isApproveModelOpen: true,
        mfaPayload: {
          ...prevState.mfaPayload,
          stRegistrationId: device.id,
        },
      }));
      const payload: any = {
        ...(state.mfaPayload || {}),
        deviceList: undefined,
        stRegistrationId: device.id,
      };

      getPortfolioApi("navigateToApproveModal", payload);
    } catch (error) {
      console.log("error decrypting registration id:", error);
    }
  };

  const setStatus = (status: any) => {
    setState((prevState) => ({
      ...prevState,
      status: status,
    }));
  };

  const portfolioSubmitHandler = async (otp?: string, isManual?: boolean) => {
    try {
      const payload: any = {
        ...(state.mfaPayload || {}),
      };
      if (otp) {
        payload.totp = otp;
      }

      if (isManual) {
        getPortfolioApi("portfolioSubmitHandler", payload);
      } else {
        getPortfolioApi("portfolioSubmitHandlerOnStatus", payload);
      }
    } catch (error: any) {
      console.log("error submit otp for portfolio:", error);
    }
  };

  if (!state.status || state.status === "INITIATED") {
    return (
      <>
        <HomeSkimmer />;
        <SelectDevice
          showModal={state.isDeviceListModelOpen}
          toggleDeviceList={toggleDeviceListModel}
          navigateToApproveModal={navigateToApproveModal}
          registrations={(state.mfaPayload as any)?.deviceList}
          from="home"
        />
        <ApproveTransfer
          showModal={state.isApproveModelOpen}
          toggleApprove={toggleApprove}
          transferData={state}
          setStatus={setStatus}
          from="home"
          portfolioSubmitHandler={portfolioSubmitHandler}
        />
      </>
    );
  }
  return (
    <div
      id="dashboard-container"
      className="relative z-30 flex sm:flex-col xs:flex-col md:flex-col lg:flex-row xl:flex-row "
    >
      <div
        id="dashboard-left-container"
        className="flex flex-col xs:gap-3 xslg:gap-[1.2rem] xl:w-6/12
        xs:w-full sm:w-full p-5 overflow-y-scroll h-[94vh] no-scrollbar"
      >
        <div className="flex flex-row xs:gap-2 xslg:gap-5">
          {state.accountsHave &&
            DashboardData.map((data, index) => (
              <AccountHave
                key={"Account_List_" + index}
                type={data.type}
                accountsHave={state.accountsHave}
                accountsOwe={state.accountsOwe}
                youHaveAmount={state.youHaveAmount}
                youOweAmount={state.youOweAmount}
              />
            ))}
        </div>
        {theme === "aub" && isOpenBanking && <OpenBanking />}
        {(!user || theme === "aub") && (
          <div className="flex flex-row gap-5 w-full">
            {!user?.isRegistered && <RegisterDebtView />}
            {theme === "aub" && <EnableOpenBanking />}
          </div>
        )}
        <Services type="Services" />
        <Services type="Transaction" />
      </div>
      <div
        id="dashboard-right-container"
        className="flex flex-col lg:w-full  xl:w-6/12 md:pl-5 lg:pl-0 xl:pl-0 p-5 gap-[1.25rem] sm:pl-5 h-[94vh]"
      >
        <QuickTransfer accountsHave={state.accountsHave} />
        <RecentTsns recentTransactionsList={state.recentTransactionsList} />
      </div>
    </div>
  );
};

export default Home;
